const BearerToken = ( idToken ) => {
 return {
   toString: ( ) => {
     return `Bearer ${idToken}`;
   }
 }   
};

export default BearerToken;


// WEBPACK FOOTER //
// ./src/api/BearerToken.js